import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useMutation, useQuery } from "@apollo/client";
import { AFTER_FOURDAY_NOT_PAYMENT_ORDER, GET_FOUR_DAY_ORDER_PAYMENT, GET_PAYMENT_ORDERS } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import AdminHeader from "./AdminHeader.js";
import { UPDATE_TODAY_PAYMENT_STATUS } from "../graphql/Mutation/Ordre.js";

const channelOptions = [
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12 Days and Continuing", label: "12 Days and Continuing" },
];


const AdminAfterFourDayNotPaymentOrder = () => {
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [isOn, setIsOn] = useState(false);

    const { data: GetOrderOrder, loading, refetch } = useQuery(AFTER_FOURDAY_NOT_PAYMENT_ORDER, {
        variables: {
            page: page + 1,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            "email": searchUser,
            // "codPaymentStatus": cod_payment_status
        },
        fetchPolicy: "cache-and-network"
    })


    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    const [openClosePayment] = useMutation(UPDATE_TODAY_PAYMENT_STATUS);


    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }

    useEffect(() => {
        if (GetOrderOrder?.getAfterNotPaymentDeliveryOrder?.data) {
            setOrderData(GetOrderOrder?.getAfterNotPaymentDeliveryOrder?.data);
        }
    }, [GetOrderOrder]);
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        refetch({
            isOpenTodayPayment: tab === "Open Today Payment" ? "true" : tab === "Close Today Payment" ? "false" : undefined,
        });
        // if (tab === 'All') {
        //     setcod_payment_status('pending')
        // } else if (tab === 'Open Today Payment') {
        //     setcod_payment_status('')
        // } else if (tab === 'Close Today Payment') {
        //     setcod_payment_status('received')
        // }
        // else {
        //     setcod_payment_status('');
        // }
    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };

    const toggleClose = async (customerId, isOpen) => {
        try {
            await openClosePayment({
                variables: { input: { customerId, isOpenTodayPayment: isOpen, misspayment: true } },
            });
            refetch();
        } catch (err) {
            console.error("Error updating payment status:", err);
        }
    };
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            AdminSide Payment History
                        </h1>
                        {/* <button
                            // onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl" />
                            Export
                        </button> */}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                            />
                        </div>


                        {/* <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Order IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Order ID"
                            />
                        </div> */}
                        {/* <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Type</label>
                            <Select
                                options={typeOptions}
                                defaultValue={typeOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                        // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                        // paddingBottom: '-0.5px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',
                                    }),
                                }}
                            />
                        </div> */}
                        {/* <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div> */}

                        {/* <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={channelOptions}
                                defaultValue={channelOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            fontSize: '0.875rem',
                                            color: '#000000',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',

                                    }),
                                }}
                            />
                        </div> */}


                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}





                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Open Today Payment",
                            "Close Today Payment",
                            // "Today Payment",
                            // "In Transit",
                            // "Out For Delivery",
                            // "Delivered",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Shipment Table Section */}
                <h1 className="mt-7 mb-2 font-bold text-gray-800">
                    More 5 Days After Sending - <span className="font-medium">Payment Status</span>
                </h1>
                <div className="bg-slate-50 rounded-t-lg border mb-1 border-slate-300">
                    <div className=" max-h-[600px] overflow-y-auto overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                            <thead className="bg-slate-100 text-gray-700  sticky top-0 z-10">
                                <tr>
                                    <th className="px-4 py-3">No.</th>
                                    <th className="px-4 py-3">Email ID</th>
                                    <th className="px-4 py-3">Total Pay Amount (Today)</th>
                                    {/* <th className="px-4 py-3">View Bank Details</th> */}
                                    <th className="px-4 py-3">Shipment Details</th>
                                    <th className="px-4 py-3" >Close</th>
                                    {/* <th className="px-4 py-3">Receiver Details (To)</th>
                                    <th className="px-4 py-3">COD Collectable (₹)</th>
                                    <th className="px-4 py-3">COD Collection (₹)</th>
                                    <th className="px-4 py-3">Payment Type</th>
                                    <th className="px-4 py-3">RTO Charge (₹)</th>
                                    <th className="px-4 py-3">Shipment Charge (₹)</th>
                                    <th className="px-4 py-3">Total Amount (₹)</th>
                                    <th className="px-4 py-3">Net Receivable Amount (₹)</th>
                                    <th className="px-4 py-3">Receive Amount Date</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">Receive Payment</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="16" className="text-center py-20">
                                            <SpinLoader classNamecolor="true" />
                                        </td>
                                    </tr>
                                )
                                    : orderData?.length > 0 ?
                                        (
                                            orderData.map((shipment, index) =>
                                            (
                                                <tr className="border-t bg-white hover:bg-slate-50 transition-all">
                                                    <td className="px-4 py-3 text-gray-700 font-medium">{page * limit + index + 1}</td>
                                                    <td className="px-4 py-3 text-blue-600 font-semibold cursor-pointer">{shipment?.email}</td>
                                                    <td className="px-4 py-3 text-gray-700 font-bold">₹{shipment?.totalPayAmount}</td>

                                                    {/* <td className="px-4 py-3 font-semibold cursor-pointer">
                                        <span className="bg-green-200 text-green-600 px-6 py-1 rounded-lg text-sm font-semibold">
                                            Done
                                        </span>
                                    </td> */}
                                                    {/* <td className="px-4 py-3">
                                                        <div className={`relative inline-flex items-center h-6 w-12 cursor-pointer rounded-full transition-colors ${isOn ? "bg-green-500" : "bg-slate-300"
                                                            }`}
                                                            onClick={toggleSwitch}
                                                        >
                                                            <span
                                                                className={`absolute left-0 top-1/2 h-5 w-5 rounded-full bg-white shadow transform transition-transform ${isOn ? "translate-x-6 -translate-y-1/2" : "translate-x-1 -translate-y-1/2"
                                                                    }`}
                                                            ></span>
                                                        </div>
                                                    </td> */}

                                                    {/* <td className="px-4 py-3 text-blue-600 font-semibold cursor-pointer hover:underline">
                                                        Bank Details
                                                    </td> */}

                                                    <td className="px-4 py-3 text-blue-600 font-semibold cursor-pointer hover:underline">

                                                        <Link to="/adminSingleCodPayment" state={{ customerId: shipment?.customerId, email: shipment?.email }}>
                                                            View Details
                                                        </Link>
                                                    </td>
                                                    <td className="py-2.5 text-sm px-4 border-b">
                                                        <button onClick={() => toggleClose(shipment?.customerId, !shipment?.isOpenTodayPayment)}
                                                            className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                                        >
                                                            {shipment?.isOpenTodayPayment ? "Close" : "Open"}
                                                        </button></td>

                                                </tr>

                                            )
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="16" className="text-center py-20">
                                                    <NoDataFound />
                                                </td>
                                            </tr>
                                        )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {GetOrderOrder?.getAfterNotPaymentDeliveryOrder?.count > 0 && (
                    <CustomPagination
                        totalItems={GetOrderOrder?.getAfterNotPaymentDeliveryOrder?.count || 0} // Total number of items
                        limit={limit}
                        pageNo={page} // Current page number (zero-based index)
                        handlePageClick={handlePageClick} // Handler to change page
                    />)}


            </div >
            {/* <Footer /> */}
        </>
    )
}
export default AdminAfterFourDayNotPaymentOrder
